import { mapEnumToOptions } from '@abp/ng.core';

export enum Operation {
  ServiceEntrySheetGeneration = 0,
  SendServiceEntrySheetGenerationEmail = 1,
  SendServiceEntrySheetRevertEmail = 2,
  ServiceEntrySheetRevert = 3,
  SendServiceEntrySheetGeneratedExternalSystems = 4,
  SendServiceEntrySheetRevertedExternalSystems = 5,
}

export const operationOptions = mapEnumToOptions(Operation);
